module.exports = "<p-inputMask #primeFocusInput slotChar=\"0\" class=\"time-comp-wrapper ui-inputtext\" (onBlur)=\"validateTimeEntered(params.value.cVal)\"\r\n[ngModel]=\"params.value.cVal\" (ngModelChange)=\"valueChanged($event);\" (focus)=\"onTextFocus()\" (keydown)=\"keyEventHandler.editKeyPressListner($event,currentRow, params.cellMetaData);\"\r\nmask=\"99:99\" placeholder=\"hh:mm\"></p-inputMask>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/time-mask/time-mask.component.html
// module id = ../../../../../src/app/shared/components/time-mask/time-mask.component.html
// module chunks = main